var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnectLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 13,
    viewBox: "0 0 70 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49 6.5251C49 8.08108 50 9.28571 51.5 9.28571C52.55 9.28571 53.25 8.73359 53.65 8.03089L56.85 10.39C55.9 11.695 54.1 13 51.5 13C47.85 13 44.8 10.6409 44.8 6.5251C44.8 2.50965 47.65 0 51.5 0C54.05 0 55.7 1.15444 56.8 2.66023L53.65 5.01931C53.25 4.3166 52.55 3.71429 51.5 3.71429C49.9 3.71429 49 4.96911 49 6.5251ZM10.35 12.7992H14.95L9.75 0.250965H5.25L0 12.7992H4.65L7.5 5.27027L10.35 12.7992ZM62.15 3.81467H58.45V0.250965H70V3.81467H66.3V12.7992H62.15V3.81467ZM43.05 0.250965H33.05V12.7992H43.05V9.23552H37.25V3.81467H43.05V0.250965ZM16.85 0.250965H20.85L25.2 5.72201V0.250965H29.4V12.7992H25.6L21 7.12741V12.7992H16.85V0.250965Z",
    fill: "#615E8B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnectLogo);
export default __webpack_public_path__ + "static/media/anect-logo.73693292.svg";
export { ForwardRef as ReactComponent };